import { graphql } from "react-relay";

export const eventSchedulerSuggestedTimeFragments = {
  schedulingSlot: graphql`
    fragment EventSchedulerSuggestedTime_schedulingSlot on SchedulingSlot {
      summary {
        availableRooms
        tags
        freeAttendees
        inconvenientForAttendees
        unavailableAttendees
        focusTimeMinutesCost
        conflictingAttendees
      }
      attendanceImpacts {
        calendarId
        inconveniences
        unavailabilities
        hasConflict
        focusTimeMinutesCost
        conflictingMeetings
      }
      roomImpacts {
        roomId
        available
        tooSmall
        tooLarge
      }
      timeRange {
        id
        startTime {
          type
          dateOrDateTime
          timeZone
          offsetMinutes
          millis
        }
        endTime {
          type
          dateOrDateTime
          timeZone
          offsetMinutes
          millis
        }
      }
    }
  `,
  org: graphql`
    fragment EventSchedulerSuggestedTime_org on Org {
      id
      experiments
    }
  `,
};
